import { network } from 'services/network';

export const getTableColumns = (params: { componentKey: string }) => {
    return network.post('api/bo/getTableColumns', params).then((response) => response.data);
};
